import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import useEffectOnce from "../../../hooks/useEffectOnce";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

const LogoutRoute = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const { logout, logoutAndGoBackToMyHome, logoutAndGoToMyHomeInvestment } = useAuth();
    useEffectOnce(() => {
        const logoutFn = async () => {
            const logoutFnType = props.navigateToMyHomeInvestmentRoute 
                ? logoutAndGoToMyHomeInvestment
                : props.navigateToRedirectBackToMyHomeRoute
                    ? logoutAndGoBackToMyHome
                    : logout;
            try {
                await logoutFnType();
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        logoutFn();
    }, []);

    return (
        <LoaderWrapper showLoader={isLoading}>
            <Outlet />
        </LoaderWrapper>
    );
};

export default LogoutRoute;
